// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"N_TheComp__Zzo0e"};